import { CallHistoryMethodAction, push } from 'connected-react-router';
import { iif, mergeMap, Observable, of, tap } from 'rxjs';
import { ofType } from 'redux-observable';
import { mapTo } from 'rxjs/operators';
import { EmptyAction, SetClaimInfoLinkListAction } from '../../../../reducers';
import Constants from '../../../../../env/constants';
import { SET_CLAIM_INFO_LINK_LIST } from '../../../../reducers/types';
import { end } from '../../../../reducers/actions';
import isAuto from '../../../../../util/intakeUtil';

const redirectEpic = (
    action$: Observable<SetClaimInfoLinkListAction>,
    state: RxJSState,
): Observable<CallHistoryMethodAction<[string, unknown?]> | EmptyAction> =>
    action$.pipe(
        ofType(SET_CLAIM_INFO_LINK_LIST),
        mergeMap(() =>
            iif<CallHistoryMethodAction<[string, unknown?]>, EmptyAction>(
                () => isAuto(state.value.claim.claimInfoLinkList),
                of(push(Constants.routes.assetSelection)),
                of(state.value.claim.claimInfoLinkList[0].link).pipe(
                    tap((clientLink: string) => {
                        window.location.href = clientLink;
                    }),
                    mapTo(end()),
                ),
            ),
        ),
    );

export default redirectEpic;
